<template>
	<div style="padding: 0px;">
		<el-form :inline="false" :model="locrelpointinfo" :rules="rules" ref="locpointrelrule" label-width="120px" class="">
			<el-row >
				<el-col :span="12">
					<el-form-item label="点位类型" prop="type" >
						<el-select style="width: 100%;" filterable clearable :disabled="!editok" v-model="locrelpointinfo.type" 
							placeholder="请选择点位类型" @change="typeChange">
							<el-option v-for="item in typelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="是否默认显示" prop="defaultshow" >
						<el-select style="width: 100%;" :disabled="!editok" v-model="locrelpointinfo.defaultshow" placeholder="请选择是否默认显示">
							<el-option v-for="item in statelist" :key="item.code" :label="item.name" :value="item.code"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="'calc' == locrelpointinfo.type ">
				<el-col :span="24">
					<el-form-item label="计算点位" >
						<el-select style="width: 100%;" filterable clearable :disabled="!editok" v-model="locrelpointinfo.cid"
							placeholder="请选择计算点位" @change="pointChange">
							<el-option v-for="item in calcpointlist" :key="item.id" :label="item.objectid +' | '+ item.propertyid +' | '+ item.name" :value="item.id"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row v-show="'dev' == locrelpointinfo.type ">
				<el-col :span="12">
					<el-form-item label="设备" >
						<el-select style="width: 100%;" v-model="selecteddevid" filterable placeholder="请选设备" @change="selectDev">
							<el-option v-for="item in devList" :key="item.id" :label="item.devname" :value="item.devid"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="设备点位" >
						<el-select style="width: 100%;" v-model="selectedpointid" filterable placeholder="请选属性" @change="devPointChange">
							<el-option v-for="item in propertyList" :key="item.id" :label="item.name" :value="item.propertyid"> </el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
			<el-row >
				<el-col :span="12">
					<el-form-item label="图标" prop="iconurl">
						<el-input clearable :disabled="!editok" v-model="locrelpointinfo.iconurl" ></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="排序" prop="idx">
						<el-input-number style="width: 100%;" :disabled="!editok" v-model="locrelpointinfo.idx" :precision="2" :min="0" :max="999" label="排序"></el-input-number>
					</el-form-item>
				</el-col>
			</el-row>
			
		</el-form>
		<div style="text-align: center;">
			<el-button v-show="!editok" type="primary" @click="editok = true">修改</el-button>
			<el-button v-show="editok" plain @click="closeDlg">取消</el-button>
			<el-button v-show="editok" type="primary" @click="saveLocPointRel">保存</el-button>
		</div>
		
	</div>
</template>

<script> 
	import { addLocPointCalc,queryOrgDevList,queryPropertyListByDev,
		queryCalcPointsByPage } from '/static/apiUrl.js'
	export default {
		name : 'AddLocPoint',
		data() {
			return {
				editok: false,
				disabled_cord: false,
				selecteddevid : '',
				selectedpointid : '',
				locrelpointinfo : {
					id: "",
					type : '',
					objectid: "",
					orgid : '',
					locid : '',
					controlid: "",
					devid : '',
					propertyid : '',
					idx: 1,
					defaultshow : '',
					homepageshow : '',
					iconurl : '',
					locname : '',
				},
				statelist : [
					{
						code : 'Y',
						name : '显示'
					},
					{
						code : 'N',
						name : '不显示'
					}
				],
				typelist : [
					{
						code : 'dev',
						name : '设备点位'
					},
					{
						code : 'calc',
						name : '计算点位'
					}
				],
				rules:{
					defaultshow: [
						{ required: true, message: '请选择是否默认显示', trigger: 'blur' }
					],
					type: [
						{ required: true, message: '请选择类型', trigger: 'blur' }
					],
				},
				calcpointlist : [],
				devList : [],
				propertyList : [],
			}
		},
		mounted() {
			
		},
		BeforeCreate(){
			
		},
		props: {
			add : {
				type : Boolean,
				required : false,
				default : false,
			},
			selectedloc: {
				type: Object,
				required: true
			},
		},
		watch: {
			add : {
				immediate: true,
				handler(newVal) {
					if(newVal == true){
						this.editok = true
					}else{
						this.editok = false
					}
				}
			},
			selectedloc : {
				immediate: true,
				handler(newVal) {
					this.locrelpointinfo.locid = newVal.id
					this.locrelpointinfo.locname = newVal.name
					this.locrelpointinfo.orgid = newVal.orgid
					this.initData()
				}
			},
		},
		methods: {
			initData(){
				this.calcpointlist = []
				queryCalcPointsByPage({
					pagenum : 1,
					pagesize : 1000
				}).then(res => {
					if(0 == res.code){
						this.calcpointlist = res.datas.data
					}
				})
				if(this.locrelpointinfo.orgid != null && this.locrelpointinfo.orgid != ''){
					this.devList = []
					this.propertyList = []
					queryOrgDevList({oid : this.locrelpointinfo.orgid}).then(res => {
						if(0 == res.code){
							this.devList = res.datas
						}
					})
				}
			},
			pointChange(val){
				//console.log(val)
				this.calcpointlist.forEach((item) => {
					if(item.id == val){
						this.locrelpointinfo.objectid = item.objectid
						this.locrelpointinfo.propertyid = item.propertyid
					}
				})
			},
			closeDlg() {
				this.editok = false
				if(this.add){
					this.$emit("needRelRefrash",false,false)
				}
			},
			saveLocPointRel(){
				this.$refs["locpointrelrule"].validate((valid) => {
					if (valid) {
						if(this.locrelpointinfo.locid == '' || this.locrelpointinfo.propertyid == ''){
							this.$message({
								showClose: true,
								message: "请完善数据",
								type: 'warning'
							});
							return;
						}
						//console.log(this.locrelpointinfo)
						if(this.locrelpointinfo.id != null && this.locrelpointinfo.id != ''){  //编辑
							this.$message({
								showClose: true,
								message: "暂时不支持",
								type: 'warning'
							});
						}else{ //新增
							addLocPointCalc(this.locrelpointinfo).then(res => {
								if(0 == res.code){
									this.$message({
										showClose: true,
										message: "添加成功",
										type: 'success'
									});
									this.$emit("needRelRefrash",true,false)
								}else{
									this.$message({
										showClose: true,
										message: res.message,
										type: 'error'
									});
								}
							})
						}
					} else {
						return false;
					}
				});
			},
			selectDev(v){
				let controlid = ""
				this.devList.forEach((it) => {
					if(it.devid == v){
						controlid = it.controlid
						this.locrelpointinfo.controlid = it.controlid
					}
				})
				this.locrelpointinfo.devid = this.selecteddevid
				queryPropertyListByDev({
					cid : controlid,
					did : this.selecteddevid,
				}).then(res => {
					if(0 == res.code){
						this.propertyList = res.datas
					}
				})
			},
			devPointChange(v){
				this.locrelpointinfo.propertyid = v
			},
			typeChange(v){
				if("dev" == v){
					this.locrelpointinfo.objectid = ''
					this.locrelpointinfo.propertyid = ''
				}else if('calc' == v){
					this.locrelpointinfo.controlid = ''
					this.locrelpointinfo.devid = ''
					this.locrelpointinfo.propertyid = ''
				}
			}
		},
		beforeDestroy() {
			
		},
	}
</script>

<style scoped>
	
</style>